export default "__VITE_ASSET__$5P55fVE__"